/* eslint-disable no-underscore-dangle */
import { axiosV1 } from 'interceptors/axios';
import alertBodyTypes from 'modules/_shared/components/Alert/alertBodyTypes';
import types from 'redux/actions/actionTypes';
import { decryptResponse } from 'utils/token';

import { addAlert } from '../../_shared/redux/alertActions';

// eslint-disable-next-line import/prefer-default-export
export const updateShare = (share, society) => async (dispatch) => {
  try {
    const { data } = await axiosV1.put(`/shares`, {
      _id: share._id,
      tag: share.tag,
      encumbrances: share.encumbrances,
    });
    const decodedData = await decryptResponse(data);
    const updatedSociety = {
      ...society,
      shares: society.shares.map((s) =>
        s._id === share._id ? { ...decodedData } : s
      ),
    };

    dispatch({
      type: types.UPDATE_SOCIETY,
      society: updatedSociety,
    });

    dispatch(addAlert(alertBodyTypes.SHARE_UPDATED));
    return decodedData;
  } catch (error) {
    dispatch(addAlert(alertBodyTypes.ERROR_SHARE_UPDATED));
  }
};
